import React from 'react';
import Footer from '../Footer.js';
//import videoDemo from '../images/demo-ipicim.mp4';
import Whatsapp from './../../images/whatsapp.png';
import GoogleForm from './GoogleForm';

export class Matricula extends React.Component {
	render() {
		return (
			<>
				<section className="wrapperMatricula whiteBg">
					<div className="wrapInner blueGreenGradient">
							<div className="hamburgerMenu">☰</div>
							<div className="wrapContentIner">
								<h2 className="blanco centerText highlightHuge">¿PORQUÉ MATRICULAR EN IPICIM?</h2>
									
									<div className="flexCenter">
										<div className="twoCols">
											<p className="blanco">Por más de 40 años, la institución se ha caracterizado por buscar la excelencia académica y fomentar la salud mental y el bienestar emocional. IPICIM no sólo es un lugar para adquirir los contenidos académicos requeridos, es una serie de experiencias en donde los estudiantes adquieren herramientas que responden a las necesidades y exigencias actuales, las cuales sí garantizan el éxito profesional, tales como resolución de problemas, investigación, trabajo en equipo, autorregulación, comunicación, etc.</p>
											</div>

											<div className="twoCols">
												<iframe width="100%" height="315" src="https://www.youtube.com/embed/f-D68pXbfh0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
												</div>
									</div>
							</div>
						</div>

						<div className="imageTour fullHeight">
							<div className="wrapContentIner height100 relative">
								<h2 className="turquesa2 centerText absolute highlightHuge">RESERVE UN TOUR</h2>

								<div className="flexCenter height100">
										<div className="whiteDifuse">
											<a href="http://wa.me/50671688408">
											<h3 className="turquesa3 centerText highlightBig">Escríbanos<br/>por WhatsApp</h3>
												<img width="32" height="auto" src={Whatsapp} alt="IPICIM preescolar primaria secundaria primary high school english steam"/>
											</a>
										</div>
								</div>

							</div>
						</div>

						<div className="wrapContentIner">
							<div className="googleForm">
								<GoogleForm/>
							</div>
						</div>

		     </section>

		     <Footer/>
			</>
		)
	}
}

export default Matricula